export function arrayToMap<T extends { id: string }>(arr: T[]): Map<string, T> {
  return new Map(arr.map((item) => [item.id, item]));
}
